import React, { useEffect, useRef } from 'react';

const OVERFLOW_THRESHOLD_HEIGHT = 770;

/**
 * 画面の高さを監視し要素の重なりを検知するカスタムフック
 * 要素が重なりスクロールが必要な場合は、isOverflowingをtrueにする。
 *
 * @returns {Object} - menuWrapperRefとisOverflowingを含むオブジェクトを返す。
 */
const useScrollCheck = () => {
  const menuWrapperRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = React.useState(false);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const menuWrapper = menuWrapperRef.current;
    if (menuWrapper) {
      const handleScroll = () => {
        const { clientHeight } = menuWrapper;
        setIsOverflowing(clientHeight < OVERFLOW_THRESHOLD_HEIGHT);
      };

      const handleResize = () => {
        handleScroll();
      };

      window.addEventListener('resize', handleResize);
      handleScroll();

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return { menuWrapperRef, isOverflowing };
};

export default useScrollCheck;
